import { generatePath } from 'react-router';

import CopyCell from 'components/Grids/DataGrid/Cells/CopyCell';
import RowCell from 'components/Grids/DataGrid/Cells/RowCell';
import { appReactMemo } from 'hocs';
import { ROUTES } from 'routes/config/constants';

import { TClientInstrumentRowCellProps } from './types';

const ClientIdCell = ({ item, ...rest }: TClientInstrumentRowCellProps) => {
  const { PARAMS, PATH } = ROUTES.CLIENTS_MANAGEMENT.SUB_PATH.CLIENTS.SUB_PATH.CLIENT;
  const { id } = item.customer || {};

  const clientPath = generatePath(PATH, {
    [PARAMS.ID]: String(id),
  });

  return (
    <RowCell {...rest} item={item}>
      <CopyCell
        enableFullText={rest.isStretched}
        item={item}
        text={item.customer.merchantCustomerId}
        to={id ? clientPath : undefined}
      />
    </RowCell>
  );
};

export default appReactMemo(ClientIdCell);
